import { apiClient } from '@devd-client/api';
import { getToken, getOrgId, getUserId } from '@devd-client/devd/auth';
import {
  TeamMembersResponse,
  MemberAllocationResponse,
  MembersResponse,
  TeamAllocationResponse,
  PhasesResponse,
  InitiativeUpdateStatusResponse,
  DeliverableDataResponse,
  DeliverablesPageResponse,
} from '../helpers/Initiatives.types';

export const getDeliverablesPage = (): Promise<DeliverablesPageResponse> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/Deliverables`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const postInitiative = (params: any): Promise<any> => {
  return apiClient(`/v2/initiative/org/${getOrgId()}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const editInitiative = (params: any): Promise<any> => {
  return apiClient(`/v2/initiative/org/${getOrgId()}/${params.id}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const deleteInitiative = (params: any): Promise<any> => {
  return apiClient(`/v2/initiative/org/${getOrgId()}/${params.id}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
};

export const getTeamMembers = (team: string): Promise<TeamMembersResponse> =>
  apiClient(`/v1/team/members/org/${getOrgId()}/team/${team}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllocationByMember = (
  initiativeId: string
): Promise<MemberAllocationResponse> =>
  apiClient(
    `/v1/org/${getOrgId()}/initiative/${initiativeId}/member-allocation`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getMembers = (params?: {
  pageNo?: number;
  pageSize?: number;
  searchTerm?: string;
}): Promise<MembersResponse> =>
  apiClient(
    `/v1/employee/org/${getOrgId()}${
      params
        ? `?pageNo=${params.pageNo || 0}&pageSize=${params.pageSize || 20}${
            params.searchTerm ? `&searchTerm=${params.searchTerm}` : ''
          }`
        : ''
    }`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const updateAllocation = (params: {
  initiativeId?: string;
  allocationList?: any;
}): Promise<any> => {
  return apiClient(
    `/v1/org/${getOrgId()}/initiative/${
      params?.initiativeId
    }/team-allocation/create`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params?.allocationList),
    }
  );
};

export const getAllocation = (
  initiativeId: string
): Promise<TeamAllocationResponse> =>
  apiClient(
    `/v1/org/${getOrgId()}/initiative/${initiativeId}/team-allocation`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const updatePhase = (params: {
  initiativeId?: string;
  phasesList?: any;
}): Promise<any> => {
  return apiClient(
    `/v1/org/${getOrgId()}/initiative/${params?.initiativeId}/phase/create`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params.phasesList),
    }
  );
};

export const getPhases = (initiativeId: string): Promise<PhasesResponse> =>
  apiClient(`/v1/org/${getOrgId()}/initiative/${initiativeId}/phase`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const getInitiativeUpdateStatus = (
  initiativeId: string
): Promise<InitiativeUpdateStatusResponse> =>
  apiClient(`/v2/initiative/update/${initiativeId}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const postInitiativeUpdateStatus = (params: any): Promise<any> => {
  return apiClient(`/v2/initiative/update/${params.initiative}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const getDeliverableData = (
  id: string,
  type: string
): Promise<DeliverableDataResponse> =>
  apiClient(`/v2/initiative/org/${getOrgId()}/${id}/deliverable/${type}/type`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const addFavouriteDeliverable = (params: any): Promise<any> =>
  apiClient(`/v1/user/${getUserId()}/preference/deliverable`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params.data),
  });

export const deleteFavouriteDeliverable = (params: any): Promise<any> => {
  return apiClient(
    `/v1/user/${getUserId()}/preference/deliverable/${params.data.id}`,
    {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};
